// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a0f6a95b","337":"a6519b19","667":"1b7c7fa3"}[chunkId] + ".chunk.js";
};